class TypedMap extends Map {
  get(key) {
    return super.get(key);
  }
  set(key, value) {
    if (value !== undefined) {
      super.set(key, value);
    }
    return this;
  }
}
export const createApiClientContext = context => new TypedMap(Object.entries(context));
//# sourceMappingURL=createApiClientContext.js.map